import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountHelpSetupWizard implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountHelpSetupWizardContainer";
    }
    render(){
        // console.log("setup wizard");
    }
}